export function Label({ children }) {
  return (
    <span className="text-xs font-bold uppercase tracking-[0.15em] text-muted-foreground">
      {children}
    </span>
  );
}

export function Panel({ title, children, action, testId }) {
  return (
    <div data-testid={testId} className="border border-border bg-card">
      {(title || action) && (
        <div className="flex items-center justify-between border-b border-border px-5 py-3.5">
          <span className="text-xs font-bold uppercase tracking-[0.15em] text-muted-foreground">
            {title}
          </span>
          {action}
        </div>
      )}
      <div className="p-5">{children}</div>
    </div>
  );
}

export default function SplitLayout({ left, right }) {
  return (
    <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
      <div className="space-y-6">{left}</div>
      <div className="lg:sticky lg:top-24 lg:self-start space-y-6">{right}</div>
    </div>
  );
}
